import React from "react";
import styles from "./style.scss";
import IdeaBulbImage from "images/icon/idea_bulb.svg";
import { trackAction } from "utils/helper/analytics";

interface Props {
  recommendation: string[];
  onClickTips: (tip: string) => void;
}
export const Recommendation: React.FC<Props> = ({
  recommendation,
  onClickTips
}) => {
  return (
    <div className={styles.wrapper}>
      <div className={styles.title}>こんな質問はいかがですか？</div>
      {recommendation.map(tip => (
        <button
          key={tip}
          className={styles.itemButton}
          type="button"
          onClick={event => {
            trackAction("clickAiTips");
            onClickTips(tip);

            if (event.detail > 0) {
              // クリック後にフォーカスを外す
              event.currentTarget.blur();
            }
          }}
        >
          <img src={IdeaBulbImage} alt="idea" />
          <span className={styles.text}>{tip}</span>
        </button>
      ))}
    </div>
  );
};
